import { useParams } from "react-router-dom";
import { useInvoice } from "@/hooks/useInvoices";
import { Skeleton } from "@/components/ui/Skeleton";
import { EmptyState } from "@/components/ui/EmptyState";
import { EmailPreview } from "@/routes/invoicing/EmailPreview";

export default function Email() {
  const { period, tenant } = useParams<{ period: string; tenant: string }>();
  const { data: invoice, loading } = useInvoice(period ?? null, tenant ?? null);
  if (loading) return <Skeleton className="h-64 w-full" />;
  if (!invoice) return <EmptyState title="Nie znaleziono faktury" />;
  return <EmailPreview invoice={invoice} />;
}
